import { HubDataSource, HubItemDataSource } from "client/Api/Hub/hub";
import { HubItemKind } from "client/Api/Hub/hubItemCategories";

export function isHubItemDataSource(value: HubDataSource): value is HubItemDataSource {
	return value === HubDataSource.Announcement
		|| value === HubDataSource.KnowledgeItem
		|| value === HubDataSource.Event;
}

export const hubDataSourceToHubItemKindMap: Record<HubItemDataSource, HubItemKind> = {
	[HubDataSource.Announcement]: HubItemKind.Announcement,
	[HubDataSource.Event]: HubItemKind.Event,
	[HubDataSource.KnowledgeItem]: HubItemKind.KnowledgeItem
};

export const hubItemKindToHubDataSourceMap: Record<HubItemKind, HubItemDataSource> = {
	[HubItemKind.Announcement]: HubDataSource.Announcement,
	[HubItemKind.Event]: HubDataSource.Event,
	[HubItemKind.KnowledgeItem]: HubDataSource.KnowledgeItem
};
